export const DEFAULT_INTERACTION_EXP_CONFIG = {
    emoticons: false,
    likeDislike: false,
    likeShare: false,
};
export const INTERACTION_EXP_DELAY = 3000;
export const STICKER_TRAY_ELEMENTS = [
    'https://g.glance-cdn.com/public/content/assets/xiaomi/Heart.gif',
    'https://g.glance-cdn.com/public/content/assets/xiaomi/starry-eyed.gif',
    'https://g.glance-cdn.com/public/content/assets/xiaomi/grinning.gif',
    'https://g.glance-cdn.com/public/content/assets/xiaomi/cool.gif',
    'https://g.glance-cdn.com/public/content/assets/xiaomi/rollingeyes.gif',
    'https://g.glance-cdn.com/public/content/assets/xiaomi/raisedeyebrows.gif',
];
export const LIKE_TITLE = 'Yayy';
export const DISLIKE_TITLE = 'Hmm';
export const LIKE_DISLIKE_MESSAGE = 'of India agree with you';
export const MAX_LIKES = 70;
export const MIN_LIKES = 50;
//# sourceMappingURL=interaction.js.map